import { createI18n } from 'vue-i18n';

import { WEB_LOCALES } from '@/shared/web/type';

import { CN } from './cn';
import { ENG } from './en';
import { KG } from './kg';
import { russianPluralizationRule } from './pluralization';
import { RU } from './ru';
import type { MessageSchema } from './types';

const messages: MessageSchema = {
  RU,
  KG,
  ENG,
  CN,
};

const instance = createI18n<MessageSchema, WEB_LOCALES>({
  legacy: false,
  locale: WEB_LOCALES.RU,
  pluralRules: {
    [WEB_LOCALES.RU]: russianPluralizationRule,
  },
  messages,
});

export default instance;
export const i18n = instance.global;
